import { CasinoGameEnum, CurrencyEnum, FiatCurrencyEnum, SoftGameCatEnum } from '../api/api';
export { CasinoGameEnum, CurrencyEnum, FiatCurrencyEnum, SoftGameCatEnum };
export var BetType;
(function (BetType) {
    BetType["AllBets"] = "all-bets";
    BetType["MyBets"] = "my-bets";
    BetType["HighRollers"] = "high-rollers";
    BetType["Races"] = "races";
})(BetType || (BetType = {}));
